module.exports = __webpack_public_path__ + "media/src/ui/icons/MP4-7d12d1cfb6b451aae265458b87416fce.svg";